import { Link } from 'react-router-dom';
import { Phone, PhoneCall, ChevronLeft } from 'lucide-react';
import { PageHeader } from '@/components/ui/PageHeader';
import { ProfileSection, BundleSection } from '@/components/profiles/ProfileSection';

export default function VoiceProfiles() {
  return (
    <div className="flex flex-col h-full overflow-hidden">
      <PageHeader
        title="Forfaits Voix"
        subtitle="Profils SIP (sip-trunk, codec, dial-plan) + transport voix (VLAN voice, ip-host)"
        actions={
          <Link to="/app/profiles/data" className="btn btn-sm">
            <ChevronLeft size={11} /> Forfaits Data
          </Link>
        }
      />

      <div className="flex-1 overflow-auto p-4 flex flex-col gap-4">
        <div className="grid grid-cols-3 gap-3">
          <StatTile icon={<Phone size={14} />} label="Voice (SIP)" color="text-c5" />
          <StatTile icon={<PhoneCall size={14} />} label="Voice Transport" color="text-c4" />
          <StatTile icon={<svg width={14} height={14} />} label="Bundles voix" color="text-brand" />
        </div>

        <ProfileSection kind="voice" />
        <ProfileSection kind="voice_transport" />
        <BundleSection filter="voice" />
      </div>
    </div>
  );
}

function StatTile({ icon, label, color }: { icon: React.ReactNode; label: string; color: string }) {
  return (
    <div className="card card-pad flex items-center gap-2.5">
      <div className={`w-7 h-7 rounded bg-surface-hi flex items-center justify-center ${color}`}>
        {icon}
      </div>
      <div>
        <div className="text-xs font-semibold">{label}</div>
        <div className="text-[10.5px] text-text-faint">profils + bundles</div>
      </div>
    </div>
  );
}
